import Icon from '@ant-design/icons';

const LogoSvg = (props: any) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_43_174)">
        <path
          d="M18 0C19.2387 0 20.3899 0.375318 21.3457 1.01855L10.9404 12.5293C10.8807 12.6042 10.7645 12.6123 10.6943 12.5459L6.49219 8.56934C6.30087 8.38842 5.99012 8.38836 5.79883 8.56934L3.14355 11.082C2.95229 11.263 2.95238 11.5563 3.14355 11.7373L8.87793 17.1631C10.1783 18.3931 12.3289 18.2477 13.4316 16.8555L23.9346 5.11816C23.977 5.40602 24 5.70037 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6C0 2.68629 2.68629 0 6 0H18Z"
          fill="#08CF65"
        />
      </g>
      <defs>
        <clipPath id="clip0_43_174">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoIcon = (props: any) => <Icon component={LogoSvg} {...props} />;
